"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ajaxFilter = void 0;
const support_1 = require("./support");
const ajaxFilter = (url = null) => {
    /**
     * Ajax filters
     */
    const ajaxFilters = document.querySelectorAll('[data-ajax="filter"]');
    const ajaxContent = document.querySelectorAll('[data-update]');
    const ajaxFetch = (url) => {
        const xmlhttp = new XMLHttpRequest();
        ajaxContent.forEach(function (element) {
            element.classList.add('is-loading');
        });
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
                if (xmlhttp.status === 200) {
                    const parser = new DOMParser();
                    const htmlDocument = parser.parseFromString(xmlhttp.response, "text/html");
                    const timeout = 500;
                    setTimeout(function () {
                        ajaxContent.forEach(function (element) {
                            let name = element.getAttribute('data-update');
                            element.innerHTML = htmlDocument.documentElement.querySelector('[data-update="' + name + '"]').innerHTML;
                            element.classList.remove('is-loading');
                            window.history.pushState('', '', url);
                        });
                    }, timeout);
                }
                else if (xmlhttp.status === 400) {
                    console.warn('There was an error 400');
                }
                else {
                    console.warn(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', url, true);
        xmlhttp.send();
    };
    document.addEventListener('click', function (e) {
        const target = e.target;
        if (target.matches('.pagination a')) {
            e.preventDefault();
            ajaxFetch(target.getAttribute('href'));
        }
    });
    ajaxFilters.forEach(function (filter) {
        let buttonRefresh = filter.querySelector('[data-ajax="hidden"]');
        if (buttonRefresh) {
            buttonRefresh.parentNode.removeChild(buttonRefresh);
        }
        filter.addEventListener('change', function (e) {
            triggerFilter(filter);
        });
    });
    const triggerFilter = (filter) => {
        let params = (0, support_1.serialize)(filter);
        if (params) {
            params = filter.getAttribute('action').indexOf('?') > -1 ? '&' + params : '?' + params;
        }
        else {
            params = '?all';
        }
        ajaxFetch(filter.getAttribute('action') + params);
    };
};
exports.ajaxFilter = ajaxFilter;
